import training from './training'

const sbs = {
  path: 'sbs_domain',
  component: resolve => require(['../../../pages/domain/sbs'], resolve),
  children: [
    training
  ]
}

export default sbs
